import actions from './actions';

const {
  GET_ELECTRICITY_PRICES_BEGIN,
  GET_ELECTRICITY_PRICES_FAILED,
  GET_ELECTRICITY_PRICES_SUCCESS,
  ADD_ELECTRICITY_PRICE_BEGIN,
  ADD_ELECTRICITY_PRICE_FAILED,
  ADD_ELECTRICITY_PRICE_SUCCESS,
  DELETE_ELECTRICITY_PRICE_BEGIN,
  DELETE_ELECTRICITY_PRICE_FAILED,
  DELETE_ELECTRICITY_PRICE_SUCCESS,
  UPDATE_ELECTRICITY_PRICE_BEGIN,
  UPDATE_ELECTRICITY_PRICE_FAILED,
  UPDATE_ELECTRICITY_PRICE_SUCCESS,
} = actions;

const initState = {
  electricityPrices: [],
  total: 0,
  currentPage: 1,
  pageLimit: 50,
  loading: false,
  error: null,
};

const ElectricityPriceReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_ELECTRICITY_PRICES_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_ELECTRICITY_PRICES_SUCCESS:
      return {
        ...state,
        electricityPrices: data.electricityPrices,
        total: data.total,
        currentPage: data.currentPage || 1,
        pageLimit: data.pageLimit || state.pageLimit,
        loading: data.currentPage ? false : true,
      };
    case GET_ELECTRICITY_PRICES_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_ELECTRICITY_PRICE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_ELECTRICITY_PRICE_SUCCESS:
      return {
        ...state,
        electricityPrices: data,
        loading: false,
      };
    case ADD_ELECTRICITY_PRICE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_ELECTRICITY_PRICE_BEGIN:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_ELECTRICITY_PRICE_SUCCESS:
      return {
        ...state,
        electricityPrices: data,
        loading: false,
      };
    case UPDATE_ELECTRICITY_PRICE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_ELECTRICITY_PRICE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_ELECTRICITY_PRICE_SUCCESS:
      return {
        ...state,
        electricityPrices: data,
        total: state.total - 1,
        loading: false,
      };
    case DELETE_ELECTRICITY_PRICE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

export default ElectricityPriceReducer;
